import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { StorageService } from '@/services/storage.service';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

let supabase: SupabaseClient | null = null;

try {
  if (supabaseUrl && supabaseAnonKey) {
    supabase = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    });

    // Não limpar automaticamente a sessão da API ao receber SIGNED_OUT do Supabase.
    // O app usa tokens próprios (API JWT + refresh) e esse evento pode ocorrer em
    // cenários que não significam logout real do usuário na API.
    supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_OUT' && !StorageService.getRefreshToken()) {
        import('@/stores/auth.store').then(({ useAuthStore }) => {
          useAuthStore.setState({ user: null });
        });
      }
    });
  } else {
    console.warn('Missing Supabase environment variables. Please configure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
  }
} catch (error) {
  console.error('Error initializing Supabase:', error);
}

export { supabase };

